'use client';

import { useState, useEffect } from 'react';
import { isDemoMode, getDemoToggleUrl } from '@/lib/demo-mode';
import { Eye, EyeOff, Presentation } from 'lucide-react';

export function DemoModeToggle() {
  const [demoMode, setDemoMode] = useState(false);

  useEffect(() => {
    setDemoMode(isDemoMode());
  }, []);

  const toggleDemo = () => {
    window.location.href = getDemoToggleUrl(demoMode);
  };

  if (!demoMode) {
    // Im normalen Modus: Kleiner, unauffälliger Toggle
    return (
      <button
        onClick={toggleDemo}
        className="fixed bottom-4 right-4 bg-gray-100 hover:bg-gray-200 text-gray-600 p-2 rounded-full shadow-lg transition-all z-50"
        title="Demo-Modus für Kundenpräsentationen aktivieren"
      >
        <Presentation className="h-4 w-4" />
      </button>
    );
  }

  // Im Demo-Modus: Prominenter Banner
  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-500 to-purple-600 text-white py-2 px-4 z-50 shadow-lg">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-2">
          <Presentation className="h-5 w-5" />
          <span className="font-medium">
            🎬 DEMO-MODUS - Präsentationsdaten für Kundengespräche
          </span>
          <span className="text-blue-100 text-sm">
            (Pflegeheim, Industriepark, Metallbau Steffens)
          </span>
        </div>
        <button
          onClick={toggleDemo}
          className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded text-sm font-medium transition-colors"
        >
          ← Zurück zu echten Daten
        </button>
      </div>
    </div>
  );
}

export function DemoModeIndicator() {
  const [demoMode, setDemoMode] = useState(false);

  useEffect(() => {
    setDemoMode(isDemoMode());
  }, []);

  if (!demoMode) return null;

  return (
    <div className="mt-12"> {/* Platz für Demo-Banner */}
    </div>
  );
}
